"use client";

import React from "react";
import { Car, CarFront, Gem, Truck, ArrowRight } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const categories = [{
  id: "diagnostics",
  name: "ENGINE DIAGNOSTICS\xA0",
  description: "Advanced computer analysis to pinpoint performance issues and sensor failures.",
  icon: Car,
  features: ["Check Engine Light Diagnosis", "Sensor Calibration", "Performance Tuning"]
}, {
  id: "brakes",
  name: "Brake Systems",
  description: "Comprehensive safety inspections and repairs for your vehicle's stopping power.",
  icon: CarFront,
  features: ["Pad Replacement", "Rotor Replacement", "ABS Check"]
}, {
  id: "maintenance",
  name: "Routine Maintenance",
  description: "Scheduled servicing to keep your engine running smoothly for another 100 years.",
  icon: Gem,
  features: ["Oil & Filter Change", "State Inspection", "Wipers and Wiper Fluid"]
}, {
  id: "transmission",
  name: "TOTAL TIRE CARE",
  description: "Routine tire maintenance to make sure you get where you need to go.",
  icon: Truck,
  features: ["Flat Tire Repair", "Tire Mount and Balance", "Tire Rotation"]
}];
export default function RideCategories() {
  return <section data-section-id="224776" id="expert-care-for-every-vehicle" className="py-20 bg-background text-foreground overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center md:text-left max-w-2xl">
          <h2 className="font-default text-3xl md:text-4xl font-bold tracking-tight uppercase mb-4">Expert Care for <span className="text-primary" data-ast-id="f:/src/pages/Home/sections/RideCategories.tsx|sig:p8yc2l" data-ast-start="1771" data-ast-end="1935">Every Vehicle</span></h2>
          <p className="text-muted-foreground text-lg font-default">Dott's Garage has provided Albany with trusted mechanical expertise since 1921. Our master technicians handle everything from vintage classics to modern hybrids.&nbsp;</p>
        </div>

        <ScrollArea className="w-full pb-6 -mx-4 px-4 md:mx-0 md:px-0 md:pb-0">
          <div className="flex w-max space-x-4 md:w-auto md:grid md:grid-cols-2 lg:grid-cols-4 md:space-x-0 md:gap-6">
            {categories.map((category, i) => <div key={category.id} data-index={i} className="w-[280px] md:w-auto shrink-0">
                <Card className="h-full flex flex-col group relative overflow-hidden border-border/10 hover:border-primary/50 transition-all duration-500 hover:-translate-y-1 hover:shadow-xl hover:shadow-primary/10 bg-card rounded-md py-0">
                  <div className="absolute inset-0 bg-gradient-to-b from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                  
                  <CardHeader className="bg-primary text-primary-foreground pt-8 pb-6">
                    <div className="mb-4 relative inline-flex">
                      <div className="absolute inset-0 bg-white/20 blur-xl rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                      <div className="relative bg-white/10 p-4 rounded-md group-hover:bg-white/20 transition-colors duration-500 border border-white/20">
                        <category.icon className="w-10 h-10 text-white stroke-[2.5px] transition-transform duration-500 group-hover:scale-110" />
                      </div>
                    </div>
                    <CardTitle className="font-default text-xl font-bold uppercase tracking-tight text-white">{category.name}</CardTitle>
                    <CardDescription className="text-base font-default mt-2 text-white/80">
                      {category.description}
                    </CardDescription>
                  </CardHeader>

                  <div className="h-px bg-white/10 mx-6" />
                  
                  <CardContent className="flex-grow bg-primary text-white py-6">
                    <p className="text-xs font-bold uppercase tracking-wider text-white/60 mb-3">What we check:</p>
                    <ul className="space-y-2.5">
                      {category.features.map((feature, idx) => <li key={idx} data-index={idx} className="flex items-center text-sm text-white/90 font-default">
                          <div className="w-1.5 h-1.5 rounded-lg bg-white/60 mr-3" />
                          {feature}
                        </li>)}
                    </ul>
                  </CardContent>
                  
                  <CardFooter className="pt-6 pb-8">
                    <Button className="w-full group/btn bg-primary hover:bg-primary/90 text-primary-foreground rounded-md transition-all duration-300" variant="default" asChild>
                      <Link to="/BookAppointmentPage">
                        Schedule Service
                        <ArrowRight className="w-4 h-4 ml-2 transition-transform duration-300 group-hover/btn:translate-x-1" />
                      </Link>
                    </Button>
                  </CardFooter>
                </Card>
              </div>)}
          </div>
          <ScrollBar orientation="horizontal" className="md:hidden" />
        </ScrollArea>
        
        <div className="mt-12 text-center">
          <Link to="/OurExpertisePage" className="font-default text-primary font-bold uppercase tracking-widest hover:underline inline-flex items-center gap-2">
            See All Services
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>;
}